import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section
      className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: 'url(https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20interior%20with%20massive%20curved%20screen%20displaying%20abstract%20warm%20coral%20and%20amber%20light%20patterns%2C%20modern%20luxurious%20seating%2C%20atmospheric%20lighting%2C%20dramatic%20spotlight%20beams%2C%20rich%20velvet%20textures%2C%20premium%20cinema%20experience%2C%20high%20detail%2C%20architectural%20photography&width=1800&height=900&seq=hero-bg-01&orientation=landscape)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight font-heading">
          发现精彩，<span className="text-accent-400">就要草视频</span>
        </h1>
        <p className="text-base md:text-lg text-background-200/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          海量精选视频内容，涵盖电影、电视剧、综艺、动漫、纪录片等八大分类，为您打造专属的在线视频观看体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/dianying"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-all text-sm whitespace-nowrap cursor-pointer"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 text-background-50 backdrop-blur-sm font-medium rounded-lg hover:bg-background-50/25 transition-all text-sm whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-background-200/70">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
              120万+
            </div>
            <div className="text-xs md:text-sm mt-1">视频资源</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
              380万+
            </div>
            <div className="text-xs md:text-sm mt-1">日活用户</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
              8
            </div>
            <div className="text-xs md:text-sm mt-1">大分类</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
              9.1
            </div>
            <div className="text-xs md:text-sm mt-1">平均评分</div>
          </div>
        </div>
      </div>
    </section>
  );
}